/**
 *
 * MeasurementLeadersDetails
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
import { Table, Modal } from "antd"
import { uniq, flatMap, filter, has, debounce } from "lodash"
import alertSvg from "images/alert.svg"
import { columns } from "./columns"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
class MeasurementLeadersDetails extends React.Component {
  state = {
    rowSelected: {},
    expandedRowKeys: [],
    modalResendSurvey: false,
    modalDeleteDivOrColl: false,
    resendSurveyTo: {},
    shouldExpandAfterSearch: false,
  }

  componentDidMount = () => {
    const {
      match: { params },
      idStatus,
    } = this.props
    this.props.getLeadersDetailsWatcher({ 
      id_measure: params.id, 
      params: { id_measure_status: idStatus } 
    })
  }

  componentDidUpdate = (prevProps) => {
    // Detectar cuando termina una búsqueda (loading pasa de true a false con searchTerm activo)
    if (
      prevProps.isLoadingLeadersDetails && 
      !this.props.isLoadingLeadersDetails && 
      this.props.searchTerm
    ) {
      this.setState({ shouldExpandAfterSearch: true })
    }
    
    // Resetear expansión cuando se limpia la búsqueda
    if (prevProps.searchTerm && !this.props.searchTerm) {
      this.setState({ shouldExpandAfterSearch: false })
    }
  }

  handleTablePaginationChange = (pagination) => {
    const {
      match: { params },
      idStatus,
      searchTerm,
    } = this.props

    this.props.getLeadersDetailsWatcher({
      id_measure: params.id,
      params: {
        id_measure_status: idStatus,
        page: pagination.current,
        per_page: pagination.pageSize,
        search: searchTerm || '',
      },
    })
  }

  expandedRows = () => {
    const { leadersDetails } = this.props
    const { expandedRowKeys, shouldExpandAfterSearch } = this.state
    if (leadersDetails.length === 0) {
      return []
    }
    // Solo expandir después de que la búsqueda del backend haya terminado
    if (shouldExpandAfterSearch) {
      const response = flatMap(leadersDetails, (item) => item.id_position)
      return uniq(response)
    }

    return uniq(expandedRowKeys)
  }

  setStateFrom = (values) => {
    this.setState(values)
  }

  debounceRowSelected = debounce((record) => {
    this.setState({ rowSelected: record })
  }, 50)

  render() {
    const {
      idStatus,
      leadersDetails,
      measureStatus: { measure },
      deleteCollDivWatcher,
      resendCollDivWatcher,
    } = this.props
    const {
      rowSelected,
      expandedRowKeys,
      modalDeleteDivOrColl,
      modalResendSurvey,
      resendSurveyTo,
    } = this.state
    return (
      <Fragment>
        <Table
          bordered
          size="small"
          className={`measurement-details-table ${
            measure.id_measure_status === 5 ? "" : "add-style-three-column"
          }`}
          columns={columns(idStatus, measure, rowSelected, this.setStateFrom)}
          rowKey={(record) => {
            if (record.id_measure_has_employee)
              return record.id_measure_has_employee
            return record.id_position
          }}
          dataSource={leadersDetails}
          expandedRowKeys={this.expandedRows()}
          onExpand={(expanded, record) => {
            if (expanded) {
              this.setState({
                expandedRowKeys: uniq([...expandedRowKeys, record.id_position]),
              })
            } else {
              this.setState({
                expandedRowKeys: filter(
                  uniq(expandedRowKeys),
                  (item) => item !== record.id_position
                ),
              })
            }
          }}
          onRow={(record) => {
            return {
              onMouseEnter: () => this.debounceRowSelected(record),
              onMouseLeave: () => this.debounceRowSelected({}),
            }
          }}
          loading={this.props.isLoadingLeadersDetails}
          // expandIconColumnIndex={measure.id_measure_status === 5 ? 4 : 3}
          pagination={{
            current: this.props.pagination?.current_page || 1,
            pageSize: this.props.pagination?.per_page || 15,
            total: this.props.pagination?.total || 0,
            pageSizeOptions: ["15", "25", "50", "100"],
            showSizeChanger: true,
            size: "default",
          }}
          onChange={this.handleTablePaginationChange}
        />
        <Modal
          visible={modalResendSurvey}
          okText="Reenviar"
          cancelText="Cancelar"
          bodyStyle={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
          }}
          afterClose={() => this.setState({ resendSurveyTo: {} })}
          onOk={() => {
            const {
              match: { params },
            } = this.props
            const paramsInfo = {
              idMeasure: params.id,
              idEmployee: resendSurveyTo.id_employee,
              idDivision: resendSurveyTo.id_division,
            }

            resendCollDivWatcher(paramsInfo)
            this.setState({ modalResendSurvey: false })
          }}
          onCancel={() => {
            this.setState({ modalResendSurvey: false })
          }}
          width={520}>
          <img src={alertSvg} className="alertIcon" style={{ height:30 }} />
          <span style={{ marginTop: 16, fontSize: 14 }}>
            ¿Estás seguro de que deseas reenviar la encuesta a:{" "}
            <strong>{resendSurveyTo.full_name || resendSurveyTo.name}</strong>?
          </span>
          {!resendSurveyTo.id_employee && (
            <p style={{ fontSize: 13, marginTop: 8, marginBottom: 0 }}>
              Esta será reenviada <strong>únicamente</strong> a aquellos
              colaboradores que aún no la han contestado y tienen un correo asociado.
            </p>
          )}
        </Modal>
        <Modal
          visible={modalDeleteDivOrColl}
          okText="Eliminar"
          cancelText="Cancelar"
          bodyStyle={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
          }}
          afterClose={() => this.setState({ resendSurveyTo: {} })}
          onOk={() => {
            const {
              match: { params },
            } = this.props
            const paramsInfo = {
              idMeasure: params.id,
              idEmployee: resendSurveyTo.id_employee,
              idDivision: resendSurveyTo.id_division,
            }

            deleteCollDivWatcher(paramsInfo)
            this.setState({ modalDeleteDivOrColl: false })
          }}
          onCancel={() => {
            this.setState({ modalDeleteDivOrColl: false })
          }}
          width={520}>
          <img src={alertSvg} style={{ maxHeight: "30px" }} />
          <span style={{ marginTop: 16, fontSize: 14 }}>
            {`¿Estás seguro de que deseas eliminar
              ${has(resendSurveyTo, "document") ? "a:" : "la división:"}
            `}
            <strong>{resendSurveyTo.full_name || resendSurveyTo.name}</strong>?
          </span>
          <p style={{ fontSize: 13, marginTop: 8, marginBottom: 0 }}>
            {`La acción no será revertible y se perderán
              ${
                has(resendSurveyTo, "document")
                  ? "sus respuestas, si es que las hubieran."
                  : "todas las respuestas de los colaboradores dentro, si es que las hubieran."
              }
            `}
          </p>
        </Modal>
      </Fragment>
    )
  }
}

MeasurementLeadersDetails.propTypes = {}

export default MeasurementLeadersDetails
